import React from "react";
import { default as WRadio } from "@mui/material/Radio";

function Radio(props) {
  return <WRadio {...props} />;
}

export default Radio;
